<template>
  <div class="layout-box">
    <app-header :hasScroll="hasScroll"></app-header>
    <router-view></router-view>
    <app-footer></app-footer>
  </div>
</template>
<script>
const AppHeader = () => import("./components/AppHeader.vue");
const AppFooter = () => import("./components/AppFooter.vue");
export default {
  name: "Layout",
  components: {
    AppHeader,
    AppFooter,
  },
  data() {
    return {
      loading: true,
      fullScreen: true,
      RouterState: true,
      hasScroll: false,
      router: "/",
    };
  },
  methods: {},
  mounted() {
    const _this = this;
    this.router = this.$route.path;
    if (this.router == "/blogDetail" || this.router == "/questionDetail" || this.router == "/legalDetail") {
      this.hasScroll = true;
    } else {
      this.hasScroll = !!(window.scrollY || document.documentElement.scrollTop);
    }

    window.addEventListener("scroll", () => {
      if (_this.router != "/blogDetail" && _this.router != "/questionDetail" && this.router != "/legalDetail") {
        const scrollY = window.scrollY || document.documentElement.scrollTop;
        _this.hasScroll = !!scrollY;
      } else {
        _this.hasScroll = true;
      }
    });
  },
  watch: {
    $route: function () {
      this.router = this.$route.path;
      if (this.router == "/blogDetail" || this.router == "/questionDetail" || this.router == "/legalDetail") {
        this.hasScroll = true;
      } else {
        this.hasScroll = !!(
          window.scrollY || document.documentElement.scrollTop
        );
      }
    },
  },
};
</script>
<style lang="less" scoped>
.layout {
  height: 100%;
  width: 100%;
}
.app-page {
  height: 100%;
  width: 100%;

  .app-header-el,
  .app-footer-el {
    padding: 0;
  }

  .app-container {
    background: #1d2a4c;
  }

  .app-main {
    position: absolute;
    left: 70px;
    right: 0;
    top: 58px;
    bottom: 38px;
    padding: 0;
  }
}
</style>